
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FormatMixin from "../../Application/mixins/FormatMixin";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import PagamentosMixin from "../../Pdv/mixins/PagamentosMixin";
import InstallmentsMixin from "../../Application/mixins/InstallmentsMixin";
import Cliente from "./componentes/ClienteTab.vue";
import Servicos from "./componentes/ServicosTab.vue";
import Informacoes from "./componentes/Informacoes.vue";
import Faturamento from "./componentes/FaturamentoTab.vue";
import { store } from "../storeContratos";

export default {
  name: "app-ordem-compra-form",
  props: {},
  directives: {
    mask,
  },
  data() {
    return {
      store,
      contratoId: null,
      windowWidth: window.innerWidth,
    };
  },
  mixins: [
    validationMixin,
    FormatMixin,
    SistemaMixin,
    ValidacaoMixin,
    PagamentosMixin,
    InstallmentsMixin,
  ],
  components: {
    Cliente,
    Servicos,
    Faturamento,
    Informacoes,
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    if (this.$route.params.contratoData.id_contrato_fatura) {
      this.contratoId = this.$route.params.contratoData.id_contrato_fatura;
    }
    this.getDataInit();

    this.store.currentTab = 0;

    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {},
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    handleSair() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Cancelar o lançamento em andamento?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "contratosServicos" });
          }
        });
    },
    async salvarContratoServicos() {
      const informacoes = this.store.formInformacoes;
      if (
        Number(informacoes.termino_recorrencia) === 1 &&
        (!informacoes.data_inicio ||
          !informacoes.data_termino ||
          informacoes.data_termino <= informacoes.data_inicio)
      ) {
        this.store.currentTab = 3;
        this.$toast.warning(
          "O término da vigência deve ser posterior ao início."
        );
        return;
      }

      this.addLoadingToButton("submit_contrato_servicos");
      if (Object.keys(this.$route.params).length !== 0) {
        const { id_contrato_fatura } = this.$route.params.contratoData;
        const data = this.formatDataToSendToContratoApi(
          this.store.formCliente,
          this.store.formServicos,
          this.store.formFaturamento,
          this.store.formInformacoes
        );
        try {
          await this.$http.post("/contrato-fatura/update", {
            id_contrato_fatura,
            ...data,
          });
          this.$toast.success("Contrato editado com sucesso!");
          this.$router.push({ name: "contratosServicos" });
        } catch (error) {
          this.$toast.error("Erro ao editar Contrato!");
        }
      } else {
        try {
          const data = this.formatDataToSendToContratoApi(
            this.store.formCliente,
            this.store.formServicos,
            this.store.formFaturamento,
            this.store.formInformacoes
          );
          if (this.contratoId) {
            await this.$http.post("/contrato-fatura/update", {
              id_contrato_fatura: this.contratoId,
              ...data,
            });
          } else {
            const { id_contrato_fatura } = await this.$http.post(
              "/contrato-fatura/create",
              data
            );
            this.contratoId = id_contrato_fatura;
          }
          this.$toast.success("Contrato salvo com sucesso!");
          this.$router.push({ name: "contratosServicos" });
        } catch (error) {
          this.$toast.error("Erro ao salvar Contrato");
          console.log(error);
        }
      }
      this.removeLoadingToButton("submit_contrato_servicos");
    },
    handleNext() {
      if (this.store.currentTab === 4) return;
      this.store.currentTab++;
    },
    handlePrevious() {
      if (this.store.currentTab === 0) return;
      this.store.currentTab--;
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "nutsDigital",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    toolbarDisplay() {
      return true;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    displaySubheaderOnDashboard() {
      return this.$route.name !== "dashboard";
    },
    canSaveOrcamento() {
      return this.store.currentTab === 3 || this.store.isUpdate;
    },
  },
  created() {
    this.store.currentTab = 0;
    this.store.isUpdate = false;
    if (Object.keys(this.$route.params).length !== 0) {
      const { id_contrato_fatura } = this.$route.params.contratoData;
      this.contratoId = id_contrato_fatura;
      this.store.isUpdate = true;
    }
  },
};
